import { AbstractFilterBuilder } from "./AbstractFilterBuilder";

export class LanguageFilterBuilder extends AbstractFilterBuilder {

    public build(value: string): string {
        return `["${this.table}","${this.field}","=","${value}"]`;
    }
    
}